//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.Feature.js";
let d=[[],[[[],"MakeFlatSolidInternal",{},0,0],[[],"MakeFlatSolidExternal",{},0,0],[["size","objects"],"GetBendUpCenterLines",{},0,0],[["size","objects"],"GetBendDownCenterLines",{},0,0],[["size","objects"],"GetBendTangentLines",{},0,0],[["size","objects"],"GetInnerMoldLines",{},0,0],[["size","objects"],"GetOuterMoldLines",{},0,0],[["size","objects"],"GetExteriorCurves",{},0,0],[["size","objects"],"GetInteriorCutoutCurves",{},0,0],[["size","objects"],"GetInteriorFeatureCurves",{},0,0],[["size","objects"],"GetLighteningHoleCenters",{},0,0],[["size","objects"],"GetJoggleLines",{},0,0],[["size","objects"],"GetAddedTopGeometry",{},0,0],[["size","objects"],"GetAddedBottomGeometry",{},0,0],[["size","objects"],"GetToolMarkers",{},0,0],[["numObjects"],"GetCurves",{R_:{objects:"NXObject[]"}},0,0],[["numObjects"],"GetAnnotations",{R_:{objects:"NXObject[]"}},0,0],[["size","objects"],"GetHoleFeatureCurves",{},0,0]],[]];
SPLM.Features.FlatPattern = class extends SPLM.Features.Feature{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.FlatPattern";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.FlatPattern.ObjectDataEdge = class{
    constructor(flat_pattern_object,flat_solid_object){
        this.flat_pattern_object=flat_pattern_object;this.flat_solid_object=flat_solid_object;}
    get FlatPatternObject(){return this.flat_pattern_object}
    set FlatPatternObject(val){this.flat_pattern_object = val}
    get FlatSolidObject(){return this.flat_solid_object}
    set FlatSolidObject(val){this.flat_solid_object = val}
};

SPLM.Features.FlatPattern.ObjectDataFace = class{
    constructor(flat_pattern_object,flat_solid_object,formed_body_object){
        this.flat_pattern_object=flat_pattern_object;this.flat_solid_object=flat_solid_object;this.formed_body_object=formed_body_object;}
    get FlatPatternObject(){return this.flat_pattern_object}
    set FlatPatternObject(val){this.flat_pattern_object = val}
    get FlatSolidObject(){return this.flat_solid_object}
    set FlatSolidObject(val){this.flat_solid_object = val}
    get FormedBodyObject(){return this.formed_body_object}
    set FormedBodyObject(val){this.formed_body_object = val}
};

SPLM.Features.FlatPattern.ObjectDataCsys = class{
    constructor(flat_pattern_object,flat_solid_object,formed_body_object){
        this.flat_pattern_object=flat_pattern_object;this.flat_solid_object=flat_solid_object;this.formed_body_object=formed_body_object;}
    get FlatPatternObject(){return this.flat_pattern_object}
    set FlatPatternObject(val){this.flat_pattern_object = val}
    get FlatSolidObject(){return this.flat_solid_object}
    set FlatSolidObject(val){this.flat_solid_object = val}
    get FormedBodyObject(){return this.formed_body_object}
    set FormedBodyObject(val){this.formed_body_object = val}
};

SPLM.Features.FlatPattern.ObjectDataGeneral = class{
    constructor(flat_pattern_object,flat_solid_object,formed_body_object){
        this.flat_pattern_object=flat_pattern_object;this.flat_solid_object=flat_solid_object;this.formed_body_object=formed_body_object;}
    get FlatPatternObject(){return this.flat_pattern_object}
    set FlatPatternObject(val){this.flat_pattern_object = val}
    get FlatSolidObject(){return this.flat_solid_object}
    set FlatSolidObject(val){this.flat_solid_object = val}
    get FormedBodyObject(){return this.formed_body_object}
    set FormedBodyObject(val){this.formed_body_object = val}
};

export default SPLM;